/*
 * @Author: Teemo Ding
 * @Date: 2021-09-09 16:11:10
 * @LastEditTime: 2021-10-20 13:22:17
 * @LastEditors: Teemo Ding
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Stock/data/submitData.ts
 */
export const settleData = (state) => {
  const { stockInfo, stockItems, dataValid, storeUuid } = state;
  const { supplier, stockInDate, total, orderNo, notes, warehouse } = stockInfo;

  return {
    supplier,
    stockInDate,
    total,
    orderNo,
    notes,
    stockItems,
    dataValid,
    storeUuid,
    warehouse,
  };
};
